// Sabit üretim "Üret" onay penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.fixedProduce';

export const productionFixedProduceGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Sabit üretim nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere sabit üretim fişinden üretimi onaylatır. Onaylayınca üretim fişi açılır ve hemen tamamlanır: malzemeler girdi deposundan düşer, ürün çıktı deposuna girer. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Üret'),
    body: t(`${G}.regions.body`, 'Kaç kez, malzemeler, stok'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Onayla'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kaç kez?'),
      text: t(`${G}.s1.text`, '0\'dan büyük, en fazla 50 girin (varsayılan 1). Ondalık yazılabilir: reçete 10 kg unla tanımlıysa ve 15 kg un kullanacaksanız 1,5 yazın. Altında toplam miktar yazar; örneğin "14,85 kg × 2 = 29,7 kg Lahmacun Harcı üretilecek".'),
      tips: [
        t(`${G}.s1.tip1`, '"Çıkan miktar" gerçekte kaç tane/ne kadar çıktığını yazdığınız alandır; kaç kez değiştikçe planlanan toplamı izler, siz değiştirince sabit kalır ("Planlanana eşitle" geri alır). Reçetede "Çıkan miktar değişken" işaretliyse alan hep açıktır; değilse "Çıkan miktar farklı mı?" ile açılır.'),
        t(`${G}.s1.tip2`, 'Malzemeler her zaman planlanan miktarda düşer (ör. 18 kg hamur); ürün stoğa çıkan miktar kadar girer ve birim maliyet çıkan miktara bölünür. Fiş notuna "çıkan 262 adet (planlanan 280)" yazılır. Reçetedeki beklenen aralığın dışındaysa uyarı görünür, üretim engellenmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Düşecek malzemeleri kontrol edin'),
      text: t(`${G}.s2.text`, 'Tablo ürünün aktif reçetesine göre toplam miktar için gereken malzemeleri, girdi deposundaki mevcut stoğu ve durumu gösterir: "Yeterli", "Eksik" ya da "Eksiye düşer".'),
      tips: [
        t(`${G}.s2.tip1`, '"Eksik" satır varsa (malzemede eksi stoğa izin yok) "Onayla" kapalıdır; önce stok girin ya da miktarı azaltın.'),
        t(`${G}.s2.tip2`, '"Eksiye düşer" satırları yalnız uyarıdır; üretim yapılır ve stok eksiye düşer.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Onaylayın'),
      text: t(`${G}.s3.text`, '"Onayla"ya basın. Başarılı olursa açılan fişin numarası ekranın altında görünür ve fiş listesi yenilenir. Fiş normal bir tamamlanmış fiştir; gerekirse fiş sayfasından iptal edebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Lot takipli malzemelerde lotlar otomatik seçilir (son kullanma tarihi en yakın olan önce). Tamamlama olmazsa fiş hiç açılmaz; yarım fiş kalmaz.'),
        t(`${G}.s3.tip2`, 'Üretim operasyonsuz yapılır; reçetede rota olsa da adımlar kullanılmaz.'),
      ],
    },
  ],
});
